import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const LineItem = /*#__PURE__*/ React.forwardRef((_param, ref)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item', className),
        ref: ref
    }));
});
LineItem.displayName = 'LineItem';

export { LineItem as default };
//# sourceMappingURL=LineItem.js.map
